/* eslint-disable import/prefer-default-export */

export const getFloatNumberInfo = (value: number) => {
  const pointValue = Math.floor((value * 10) % 10)
  const floorValue = Math.floor(value)
  return { pointValue, floorValue }
}
